import type { DomainHooksRegistryInterface } from "~/context/domain-hooks-context/domain-hooks-registry.interface";


import { useTweetGenerator } from "~/modules/main/hooks/use-tweet-generator/use-tweet-generator";

import { useTweetHistory } from "~/modules/main/hooks/use-tweet-history/use-tweet-history";


/**
 * Domain hook implementations
 * 
 * This is a collection of all the domain hooks that are available in the application.
 * It is used to provide the domain hooks to the application.
 * 
 * You can access them by using the `useDomainHooks` hook.
 */
export const domainHooksRegistry: DomainHooksRegistryInterface = {

    useTweetGenerator: useTweetGenerator,

    useTweetHistory: useTweetHistory,

} as DomainHooksRegistryInterface;